import { Box } from 'braid-design-system';

import { Bar } from './components/Bar';
import { BarLabel } from './components/BarLabel';
import { Indicator } from './components/Indicator';
import { IndicatorFill } from './components/IndicatorFill';
import { ScaleLabel } from './components/ScaleLabel';
import { indicatorSize } from './constants';
import { calculateSelectedPosition, calculateSelectedWidth } from './utils';

interface Props {
  scaleLabelFour: string;
  scaleLabelOne: string;
  scaleLabelThree: string;
  scaleLabelTwo: string;
  scaleValueMax: number;
  scaleValueMin: number;
  selectedValueMax?: number;
  selectedValueMin?: number;
}

export const SalaryBar = ({
  scaleLabelFour,
  scaleLabelOne,
  scaleLabelThree,
  scaleLabelTwo,
  scaleValueMin,
  selectedValueMax,
  selectedValueMin,
  scaleValueMax,
}: Props) => {
  const maxPosition = calculateSelectedPosition(
    scaleValueMax,
    scaleValueMin,
    selectedValueMax,
  );
  const minPosition = calculateSelectedPosition(
    scaleValueMax,
    scaleValueMin,
    selectedValueMin,
  );
  const width = calculateSelectedWidth(
    scaleValueMax,
    scaleValueMin,
    selectedValueMax,
    selectedValueMin,
  );
  const indicatorFillStyles = {
    left: `calc(${minPosition} + ${indicatorSize / 2}px)`,
    width,
  };

  const maxIndicatorStyles = {
    left: maxPosition,
  };

  const minIndicatorStyles = {
    left: minPosition,
  };

  const hasValidSelection = selectedValueMin !== null;

  return (
    <>
      <BarLabel />

      <Box position="relative">
        <Bar />
        {hasValidSelection && (
          <Box
            position="absolute"
            width="full"
            style={{ top: '-2px', color: 'transparent' }}
          >
            <Indicator testId="min-indicator" style={minIndicatorStyles} />
            {selectedValueMax && (
              <>
                <IndicatorFill
                  testId="fill-indicator"
                  style={indicatorFillStyles}
                />
                <Indicator testId="max-indicator" style={maxIndicatorStyles} />
              </>
            )}
          </Box>
        )}
      </Box>

      <ScaleLabel
        labelOne={scaleLabelOne}
        labelTwo={scaleLabelTwo}
        labelThree={scaleLabelThree}
        labelFour={scaleLabelFour}
      />
    </>
  );
};
